import React from 'react';
import { IconSvgProps } from '@models/common';

const DocumentText: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M5 18.333c-.92 0-1.667-.746-1.667-1.666V3.333c0-.92.746-1.666 1.667-1.666h6.667a2 2 0 0 1 1.42.588l2.99 2.99a2 2 0 0 1 .59 1.422v10c0 .92-.747 1.666-1.667 1.666H5M11.667 1.667v4.166c0 .46.373.834.833.834h4.167M8.333 7.5H6.667m6.666 3.333H6.667m6.666 3.334H6.667'
        stroke='currentColor'
        strokeWidth='1.667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DocumentText;
